import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Provider } from "react-redux";
import { useSelectorApp } from "../../lib/redux";
import { store } from "../../app/store";

const ThemeContainer = ({ children }) => {
  const themeSettings = useSelectorApp((state) => state.ui.theme);
  const theme = createTheme({
    ...themeSettings,
  });
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

/** SweetAlert portals render outside the app tree; restore Redux + MUI theme. */
export const AlertPortalProviders = ({ children }) => (
  <Provider store={store}>
    <ThemeContainer>{children}</ThemeContainer>
  </Provider>
);

export default ThemeContainer;
